module.exports = __webpack_public_path__ + "static/media/magento1-logo.4cf82deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/magento1-logo.svg
// module id = 718
// module chunks = 0